/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('Closure_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/closure/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                open: { method: 'POST', url:baseUrl+'rest/closure/open'},
                close: { method: 'POST', url:baseUrl+'rest/closure/close'}
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Closure',["Closure_Resource","ClosureData",
        function (Closure_Resource,ClosureData)
        {
            var Closure = function (resource,day,isPreviousVersion)
            {
                this.id = "";
                this.isDeleted = false;
                this.timeCreated = null;
                this.number = null;
                this.type = null;
                this.price = null;
                this.absPrice = null;
                this.status = "open";
                this.day = day;
                this.version = null;
                this.vats = null;
                if (resource!==undefined && resource!=null)
                    this.loadObject(resource);

                if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                    ClosureData.add(this);
            };

            Closure.prototype.setId = function(id)
            {
                if (!this.id)
                    this.id = id;
            };
            Closure.prototype.getId = function()
            {
                return this.id;
            };
            Closure.prototype.loadObject = function(object)
            {
                if (!this.id)
                    this.id = object.id;
                this.number = object.number;
                this.type = object.type;
                this.status = object.status;
                this.price = object.price;
                this.absPrice = object.absPrice;
                this.timeCreated = object.timeCreated;
                this.vats = object.vats;
                if (object.version)
                    this.version = object.version;

                if (object.archive && object.archive.fileUrl)
                    this.archiveUrl = object.archive.fileUrl;


            };

            Closure.prototype.getObjectResource = function()
            {
                var newClosure = new Closure_Resource();

                newClosure.id = this.id;
                newClosure.number = this.number;
                newClosure.type = this.type;
                newClosure.status = this.status;
                newClosure.price = this.price;
                newClosure.absPrice = this.absPrice;
                newClosure.vats = this.vats;
                if (this.day)
                    newClosure.dayId= this.day.id;
                return newClosure;
            };

            return Closure;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ClosureSrv',["$log","ServerSrv","Closure_Resource","ClosureData","UserActionData","Closure","DayData","DaySrv",
        function ($log,ServerSrv,Closure_Resource,ClosureData,UserActionData,Closure,DayData,DaySrv)
        {
            var closureSrv = {};

            closureSrv.query = function(successFunction,errorFunction)
            {
                Closure_Resource.query(
                    {}, //params
                    function (data) {
                        ClosureData.clear();
                        for(var i=0;i<data.length;i++)
                        {
                            new Closure(data[i]);
                        }

                        if (successFunction!== undefined)
                            successFunction();
                    },
                    function (data) {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                );
            };

            closureSrv.open = function(closure, successFunction, errorFunction) {
                ServerSrv.startSavingProcess(closureSrv.openSync, closure, successFunction, errorFunction);
            };

            closureSrv.openSync = function(closure, successFunction, errorFunction) {
                if (!closure.day || !closure.day.id) {
                    ServerSrv.endSavingProcess(false, 412);
                }
                Closure_Resource.open({dayId: closure.day.id.toString()},
                    function (data) {
                        closureSrv.saveClosureSuccess(closure, data, successFunction);
                    },
                    function (data) {
                        try {
                            let message;
                            if (data && data.data && data.data.message) {
                                if (data.status == 400) {
                                    if (errorFunction) {
                                        if (data.data.message.includes("Closure already closed")) {
                                            let closureDay = DayData.getById(closure.dayId);
                                            if (closureDay != null) {
                                                closure.day = closureDay;
                                            }
                                            closure.status = "closed";
                                            if (closure.day) {
                                                closure.day.closure = closure;
                                            }
                                            message = "La journée que vous essayez d'ouvrir a déjà été clôturée, on ne peut pas ouvrir une journée déjà clôturée";
                                        } else {
                                            closure.day.closure = null;
                                            closure.day = null;
                                            let dayInResponse = "day ";
                                            let dayIdLength = 8;
                                            let startOfDayIdInResponse = data.data.message.indexOf(dayInResponse) + dayInResponse.length;
                                            let dayIdInResponse = data.data.message.slice(startOfDayIdInResponse, startOfDayIdInResponse + dayIdLength);
                                            message = "La journée suivante est déjà ouverte : " + dayIdInResponse + ". Vous devez la fermer avant d'en ouvrir une nouvelle.";
                                        }
                                    }
                                }
                                else if (data.status == 409) {
                                    if (errorFunction) {
                                        closure.day.closure = null;
                                        closure.day = null;
                                        message = data.data.message;
                                    }
                                }
                                if(errorFunction && message){
                                    errorFunction(message);
                                }
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            closureSrv.close = function(closure, successFunction, errorFunction) {
                ServerSrv.startSavingProcess(closureSrv.closeSync, closure, successFunction, errorFunction);
            };

            closureSrv.closeSync = function(closure, successFunction, errorFunction) {
                Closure_Resource.close({id: closure.id},
                    function (data) {
                        closureSrv.saveClosureSuccess(closure, data, successFunction);
                    },
                    function (data) {
                        try {
                            if (data && data.status == 400 && data.data && data.data.message) {
                                if (errorFunction !== undefined) {
                                    if (data.data.message.includes("Closure already closed")) {
                                        let closureDay = DayData.getById(closure.dayId);
                                        if (closureDay != null) {
                                            closure.day = closureDay;
                                        }
                                        closure.status = "closed";
                                        if (closure.day) {
                                            closure.day.closure = closure;
                                        }
                                        errorFunction("La journée que vous essayez de fermer est déjà fermée");
                                    } else {
                                        closure.day.closure = null;
                                        closure.day = null;
                                        errorFunction("La journée que vous essayez de fermer n'a jamais été ouverte");
                                    }
                                }
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            closureSrv.saveClosureSuccess = function(closure, response, successFunction) {
                try {
                    closure.setId(response.id);
                    let closureDay = DayData.getById(response.dayId);
                    if (closureDay != null) {
                        closure.day = closureDay;
                    }
                    closure.status = response.status;
                    if (!closure.version || (response.version && response.version > closure.version)) {
                        closure.version = response.version;
                    }
                    if (successFunction !== undefined) {
                        successFunction(response);
                    }
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            };

            closureSrv.remove = function(closure,successFunction,errorFunction)
            {
                ClosureData.remove(closure);
                ServerSrv.startSavingProcess(closureSrv.removeSync, closure, successFunction, errorFunction);
            };
            closureSrv.removeSync = function(closure,successFunction,errorFunction)
            {
                //$timeout (function () {

                var closureRes = closure.getObjectResource();
                closureRes.$remove({id:closure.getId()}, //no params
                    function (data) {
                        if (!closure.version || (data.version && data.version > closure.version))
                            closure.version = data.version;
                        //Save on server success :
                        // -> add an user action (send message)
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };

            closureSrv.updateLocally =  function(id,resource)
            {
                var closure =  ClosureData.getById(id);
                if (closure && closure.version && resource.version && resource.version < closure.version)
                    return null;

                var day = DaySrv.getByIdAdder(resource.dayId);
                if (closure!=null) //check if resource already exist inside index (current action could be a 'cancel')
                    closure.loadObject(resource);
                else
                {
                    closure = new Closure(resource,day);//dont load closuresService (will be done after)
                    closure.id = id;
                }
                if (day)
                    day.closure = closure;


                return closure;

            };
            closureSrv.removeLocally =  function(id,resource)
            {
                var closure =  ClosureData.getById(id)
                if (closure!=null)
                {
                    if (closure.day)
                        closure.day.removeBooking(closure);
                }

                return closure;
            };
            closureSrv.addLocally =  function(id,resource)
            {
                var closure =  ClosureData.getById(id);
                if (closure && closure.version && resource.version && resource.version < closure.version)
                    return null;

                var day = DaySrv.getByIdAdder(resource.dayId);
                if (closure!=null) //check if resource already exist inside index (current action could be a 'cancel')
                    closure.loadObject(resource);
                else
                {
                    closure = new Closure(resource,day);//dont load closuresService (will be done after)
                    closure.id = id;
                }
                if (day)
                    day.closure = closure;

                return closure;
            };
            closureSrv.getPreviousVersionInstance =  function(resource)
            {
                var closure =  new Closure(resource,null,true);
                return closure;
            };

            return closureSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ClosureData',[
        function ()
        {
            var closureData =
            {
                indexClosures : [] // closure list for the entire closurelication
            };

            closureData.getById =  function(closureId)
            {
                for (var i=0;i<this.indexClosures.length;i++)
                    if (this.indexClosures[i].id==closureId)
                        return this.indexClosures[i];
                return null;
            }
            closureData.getIndexOf =  function(closure)
            {
                if (closure)
                    return this.indexClosures.indexOf(closure);
                return -1;
            }
            closureData.getByIndex =  function(index)
            {
                if (index>=0 && index<this.indexClosures.length)
                    return this.indexClosures[index];
                else
                    return null;
            }
            closureData.add =  function(closure)
            {
                this.indexClosures.push(closure);
                return this.indexClosures.length-1;
            }
            closureData.clear =  function()
            {
                closureData.indexClosures = [];
            }



            return closureData;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Closure.js